// extracted by mini-css-extract-plugin
export var indeterminate = "_1u-6";
export var md = "_1u-5";
export var semantic = "_1u-7";
export var sm = "_1u-4";
export var text = "_1u-8";
export var toggleControl = "_1u-0";
export var toggleInput = "_1u-1";
export var toggleSwitch = "_1u-2";
export var xs = "_1u-3";